import React from 'react';
import {Section} from '../../shared/enums/container';
import {useI18n} from '../../shared/hooks/useI18n';
import {BigSection} from '../../shared/templates/BigSection';
import {FaqSection} from '../../shared/templates/FaqSection';
import {HeroSection} from '../../shared/templates/HeroSection';
import {JoinSection} from '../../shared/templates/JoinSection';
import {LastNewsSection} from '../../shared/templates/LastNewsSection';
import {MainContainer} from '../../shared/templates/MainContainer';
import {PlatformSection} from '../../shared/templates/PlatformSection';
import {StartSection} from '../../shared/templates/StartSection';
import {Document} from '../layout/Document/Document';
import * as styles from '../pages.module.sass';
import {sourceTypeGenerator} from '../../util/source_type_generator.';
import {useConfig} from '../../config/context';
import {HeroSectionType} from "../../shared/templates/HeroSection/enum/hero-section-type";

function Clinic(props: any) {
  const { data, posts, locale, supportedLocales, translation } = props.pageContext;
  const config = useConfig();
  const { t } = useI18n({
    locale,
    translation,
  });

  const ROLE_TABS = {
    doctor: { title: t('doctor') },
    familyDoctor: { title: t('familyDoctor') },
  };

  data.how_to.item.map((item: any, key: number) => {
    item.image.webp = `/public-assets/img/clinics/inside_step_${key + 1}.webp`;
  });

  return (
    <Document t={t} locale={locale} supportedLocales={supportedLocales}>
      <MainContainer locales={props.locales} locale={props.locale} general_title={'clinic_title'}>
        <HeroSection
          className={styles.hero_text}
          onClick={props.roleModalHandler}
          title={data.hero.title}
          button_text={data.hero.button_text}
          background_color={Section.CLINIC}
          heroSectionType={HeroSectionType.CLINIC}
        />

        <BigSection
          opportunityTitle={data.ability.title}
          src={'/public-assets/img/clinics/ability.webp'}
          srcs={sourceTypeGenerator(data.ability.image)}
          iconWithText={data.ability.abilities}
          videoTitle={data.video.title}
          videoSrc={config.CONTENT.VIDEO.COMPANY}
          videoInfo={data.counters}
          imgAbilityClass={styles.img_ability_clinic}
          className="clinics"
        />

        <FaqSection accordeon_data={data.faq.items} title={data.faq.title} />

        <StartSection
          title={data.how_to.title}
          steps={data.how_to.item}
          src={'/public-assets/img/patient/circle.avif'}
          srcs={[
            {
              src: '/public-assets/img/clinics/circle.avif',
              type: 'image/avif',
            },
            {
              src: '/public-assets/img/clinics/circle.png',
              type: 'image/png',
            },
            {
              src: '/public-assets/img/clinics/circle.webp',
              type: 'image/webp',
            },
          ]}
          stepsClassName={styles.steps}
          stepsCircleClassName={styles.steps_circle}
        />

        <PlatformSection
          title={data.app.title}
          src={'/public-assets/img/clinics/app.webp'}
          srcPlatformMocap={sourceTypeGenerator(data.app.image)}
          benefits_description={data.app.columns}
        />

        <JoinSection
            title={data.register.title}
            locale={locale}
            description={data.register.description}
            tabs={ROLE_TABS}
            page='clinic' />

        <LastNewsSection posts={posts} title={data.news.title} />
      </MainContainer>
    </Document>
  );
}

export default Clinic;
